export const getEnvVar = (variable: string) => window?._config?.[variable] || process.env[variable]
